import { Moment } from "moment";

export default class ResultadoInternacional implements IResultadoInternacional {
  public dataBase!: Moment;
  // Valores DO MÊS
  public ganhoCapital!: number;
  public rendimentos!: number;
  public resultadoTotal!: number;
  // Resultado acumulado (propaga prejuízos mês a mês)
  public resultadoAcumulado!: number;
  // Detalhes por moeda DO MÊS (não acumulado)
  public detalhesPorMoeda!: { [moeda: string]: DetalhePorMoeda };

  constructor(param: IResultadoInternacional) {
    Object.assign(this, param);
  }
}

export interface DetalhePorMoeda {
  ganhoCapitalOriginal: number;
  ganhoCapitalBRL: number;
  rendimentosOriginal: number;
  rendimentosBRL: number;
}

interface IResultadoInternacional {
  dataBase: Moment;
  ganhoCapital: number;
  rendimentos: number;
  resultadoTotal: number;
  resultadoAcumulado: number;
  detalhesPorMoeda: { [moeda: string]: DetalhePorMoeda };
}